// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountsController from "./accounts_controller"
application.register("accounts", AccountsController)

import AutogrowController from "./autogrow_controller"
application.register("autogrow", AutogrowController)

import Braintree__DropinController from "./braintree/dropin_controller"
application.register("braintree--dropin", Braintree__DropinController)

import Braintree__PaypalController from "./braintree/paypal_controller"
application.register("braintree--paypal", Braintree__PaypalController)

import Bridge__FormController from "./bridge/form_controller"
application.register("bridge--form", Bridge__FormController)

import Bridge__MenuButtonController from "./bridge/menu_button_controller"
application.register("bridge--menu-button", Bridge__MenuButtonController)

import Bridge__NotificationBadgeController from "./bridge/notification_badge_controller"
application.register("bridge--notification-badge", Bridge__NotificationBadgeController)

import Bridge__NotificationTokenController from "./bridge/notification_token_controller"
application.register("bridge--notification-token", Bridge__NotificationTokenController)

import Bridge__SignOutController from "./bridge/sign_out_controller"
application.register("bridge--sign-out", Bridge__SignOutController)

import BulkController from "./bulk_controller"
application.register("bulk", BulkController)

import CategorySelectController from "./category_select_controller"
application.register("category-select", CategorySelectController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CompanySelectController from "./company_select_controller"
application.register("company-select", CompanySelectController)

import DegreeSelectController from "./degree_select_controller"
application.register("degree-select", DegreeSelectController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import FetchLogoController from "./fetch_logo_controller"
application.register("fetch-logo", FetchLogoController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MentionsController from "./mentions_controller"
application.register("mentions", MentionsController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import Paddle__BillingController from "./paddle/billing_controller"
application.register("paddle--billing", Paddle__BillingController)

import Paddle__ClassicController from "./paddle/classic_controller"
application.register("paddle--classic", Paddle__ClassicController)

import PricingController from "./pricing_controller"
application.register("pricing", PricingController)

import SchoolSelectController from "./school_select_controller"
application.register("school-select", SchoolSelectController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import Stripe__EmbeddedCheckoutController from "./stripe/embedded_checkout_controller"
application.register("stripe--embedded-checkout", Stripe__EmbeddedCheckoutController)

import TestController from "./test_controller"
application.register("test", TestController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import Ui__CodeMirrorController from "./ui/code_mirror_controller"
application.register("ui--code-mirror", Ui__CodeMirrorController)

import Ui__TabsController from "./ui/tabs_controller"
application.register("ui--tabs", Ui__TabsController)

import Ui__DialogController from "../../views/components/ui/dialog_component_controller"
application.register("ui--dialog", Ui__DialogController)

import RailsNestedForm from '@stimulus-components/rails-nested-form'
application.register("nested-form", RailsNestedForm)

import CodeEditorController from "./code_editor_controller"
application.register("code-editor", CodeEditorController)

import { Alert, Dropdown, Modal, Tabs, Popover, Slideover } from "tailwindcss-stimulus-components"
application.register('alert', Alert)
application.register('dropdown', Dropdown)
application.register('modal', Modal)
application.register('tabs', Tabs)
application.register('popover', Popover)
application.register('slideover', Slideover)

